
import { createPopper } from "@popperjs/core"

export default {
  name: "PortalTarget",

  props: {
    anchorRef: {
      required: true,
      validator(val) {
        return typeof window !== "undefined" && val instanceof HTMLElement
      },
    },
    contextClass: {
      type: String,
      required: true,
    },
    placement: {
      default: "bottom-start",
      type: String,
      validator(val) {
        return ["bottom", "bottom-start"].includes(val)
      },
    },
  },

  data() {
    return {
      popperInstance: null,
      portalTargetRefUid: `portalTarget-${Math.floor(Math.random() * 100)}`,
    }
  },

  emits: ["close"],

  mounted() {
    this.$nextTick(() => {
      if (!this.$slots.default || this.$slots.default.length === 0) {
        this.waitForSlotAndRender()
      } else {
        this.renderPortal()
      }
    })
    document.addEventListener("click", this.handleClickOutside)
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside)
    if (this.popperInstance) {
      this.popperInstance.destroy()
      this.popperInstance = null
    }
  },

  methods: {
    renderPortal() {
      this.popperInstance = createPopper(
        this.anchorRef,
        this.$refs[this.portalTargetRefUid],
        {
          placement: this.placement,
        }
      )

      this.$nextTick(() => this.popperInstance.update())
    },
    handleClickOutside(e) {
      const portal = this.$refs[this.portalTargetRefUid]

      const clickedInsideAnchor = e.target.closest(`.${this.contextClass}`)
      const clickedInsidePortal = portal?.contains(e.target)

      if (!clickedInsideAnchor && !clickedInsidePortal) {
        this.$emit("close")
      }
    },
  },
}
